/**
 * Translations for WhataLab
 * EN = English (default)
 * ES = Español
 */

export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      whyHedera: 'Why Hedera',
      tools: 'Tools',
      ecosystem: 'Ecosystem',
      whataSpace: 'WhataSpace',
      whataNews: 'WhataNews',
      faqs: 'FAQs',
    },

    // Hero Section
    hero: {
      allInOne: 'Trade. Verify. Automate.',
      hederaUtilitySuite: 'All in One Place.',
      description: 'Plug your business into Web3. Community-born, enterprise-ready.',
      lightningFast: 'Lightning Fast',
      enterpriseGrade: 'Enterprise Grade',
      completeSuite: 'Complete Suite',
      advancedTools: 'Advanced Tools',
      exploreToolkit: 'Explore Toolkit',
      joinDiscord: 'Join Discord',
      releasedSupply: 'RELEASED SUPPLY',
      totalHolders: 'Total Holders',
      liveStats: 'Live stats from SentX API',
    },

    // About Section
    about: {
      badge: 'Built on Hedera. Designed for Hbarbarians.',
      title: 'About WhataLab',
      ourMission: 'Our Mission',
      missionText1: 'WhataLab is a community-born innovation lab that transforms how we interact with Web3. Founded by five experts in product, community growth, and blockchain, its mission is to make Web3 useful, accessible, and functional in the real world.',
      missionText2: 'In an environment full of empty promises, we focus on practical tools: from NFT role validation to automation and verification systems on Discord, simplifying digital life on Hedera. Our philosophy of radical utility aims to seamlessly integrate Web2 and Web3.',
      missionText3: 'Building on Hedera for its speed, sustainability, and scalability. Because Web3 isn\'t about future promises, but present actions.',
      ourAchievements: 'Our Achievements',
      listenWhataSpace: 'Listen WhataSpace',
      readWhataNews: 'Read WhataNews',
      tokenRoleValidation: 'Token Role Validation',
      tokenRoleDesc: 'First web platform for Hedera NFT & HTS tokens role validation for communities with extension to make it on Discord communities & coming soon in Telegram.',
      tokenTrading: 'Token Trading Platform',
      tokenTradingDesc: 'Combine the power of the first Sniper for Hbarbarians with an order book with limit price for trade, connected with the best NFT markets & DeFi platforms built on Hedera.',
      validatedByMarkets: 'Validated by Official Markets',
      validatedDesc: 'Endorsed by SentX & Kabila, the Hedera\'s leading NFT marketplaces',
      officialDapp: 'Official dApp on Kabila',
      officialDappDesc: 'Now available in all Kabila wallets with just one click',
      whataRoadmap: 'WhataRoadmap',
      roadmapSubtitle: 'Active protocol, experiments in progress to optimize every phase of the ecosystem.',
      done: 'Done',
      working: 'Working',
      upcoming: 'Upcoming',
      joinOurJourney: 'Join Our Journey',
      joinOurJourneyDesc: 'Be part of the revolution and help shape the future of blockchain technology. Your feedback and participation drive our development.',
      getStarted: 'Get Started',
      giveFeedback: 'Give Feedback',
      // Roadmap Q4 2023
      roadmapQ42023Title: 'Project Launch',
      roadmapQ42023Item1: 'Branding presentation',
      roadmapQ42023Item2: 'WATT NFT Collection launch',
      roadmapQ42023Item3: 'MVP W·Panel Launch',
      // Roadmap H1 2024
      roadmapH12024Title: 'Project Development',
      roadmapH12024Item1: 'MVP Evolution',
      roadmapH12024Item2: 'Customers Feedback',
      roadmapH12024Item3: 'Market research for new tools',
      roadmapH12024Item4: 'Collaborations with Hedera Communities',
      roadmapH12024Item5: 'Open more customers',
      // Roadmap H2 2024
      roadmapH22024Title: 'More than MVP',
      roadmapH22024Item1: 'Plan a new product line up',
      roadmapH22024Item2: 'Add industry professional partners to the team',
      roadmapH22024Item3: 'Turn the project into a real company',
      roadmapH22024Item4: 'Scope the WPanel V1 with pro inputs',
      // Roadmap H1 2025
      roadmapH12025Title: 'Whata Hub Enterprise',
      roadmapH12025Item1: 'Establish a Spanish SL Company',
      roadmapH12025Item2: 'Launch WhataKit NFTs & W·Boost utility Token',
      roadmapH12025Item3: 'Launch MVP W·Sniper',
      roadmapH12025Item4: 'SentX Official partner',
      roadmapH12025Item5: 'Start developing new tools',
      // Roadmap H2 2025
      roadmapH22025Title: 'Whata Hub Enterprise',
      roadmapH22025Item1: 'Launch W·Sniper W·Scanner W·Trader & W·Claimer V1',
      roadmapH22025Item2: 'Launch new main web & W·Space podcast',
      roadmapH22025Item3: 'Raising external capital with new Investors',
      roadmapH22025Item4: 'Dev Team restructuring',
      // Roadmap Q1 2026
      roadmapQ12026Title: 'New Horizons',
      roadmapQ12026Item1: 'Launch WhataNews Blog',
      roadmapQ12026Item2: 'Launch W·Bridge',
      roadmapQ12026Item3: 'Launch W·Panel V2 for creators',
      roadmapQ12026Item4: 'Launch W·Panel V1 for Holders',
      roadmapQ12026Item5: 'Official dApp on Kabila & HashPack Wallets',
      // WhataTeam
      whataTeam: 'WhataTeam',
      teamSubtitle: 'The minds behind WhataLab. A team united by passion for blockchain and commitment to building useful tools.',
      roleRober: 'Founder · CEO & Designer',
      roleMartin: 'Founder · COO & Advisor',
      rolePedro: 'Founder · COS & Hedera Advisor',
      roleSergio: 'Founder · CTO & VP Product',
      roleBeanie: 'CM & Discord Manager',
      roberDesc: 'Expertise in tokenised projects with focus on Hedera, Advertising & MK. The Whata Designer & Creative Leader.',
      martinDesc: 'Remarkable experience in finance, blockchain & growing tech startups. The total Advisor of the project.',
      pedroDesc: 'Expertise in Hedera Communities, pre and post sales customer service & coordinate the public relations.',
      sergioDesc: '6+ Years experienced in Blockchain Dev. scaling apps, smart contracts & decentralized systems.',
      beanieDesc: 'Community engagement expert. Managing Discord and keeping the WhataLab community connected and thriving.',
    },

    // Why Hedera Section
    whyHedera: {
      poweredBy: 'Powered by Hashgraph Technology',
      title: 'Why We Built on Hedera',
      subtitle: 'The world\'s most advanced distributed ledger technology. Fast, fair, and secure with the lowest environmental impact in the industry.',
      lightningSpeed: 'Lightning Speed',
      lightningSpeedDesc: 'Transactions finalize in 3-5 seconds with hashgraph consensus',
      ultraLowCost: 'Ultra Low Cost',
      ultraLowCostDesc: 'Predictable, transparent fees that don\'t fluctuate with network congestion',
      carbonNegative: 'Carbon Negative',
      carbonNegativeDesc: 'The most energy-efficient distributed ledger technology',
      bankGradeSecurity: 'Bank-Grade Security',
      bankGradeSecurityDesc: 'Asynchronous Byzantine Fault Tolerance - highest level of security',
      hbarbarians: 'HBarbarians Community',
      hbarbariansDesc: 'Vibrant ecosystem of developers, creators, and innovators building together',
      developerFriendly: 'Developer Friendly',
      developerFriendlyDesc: 'Familiar tools and languages with EVM compatibility for seamless migration',
      fastest: 'Fastest',
      cheapest: 'Cheapest',
      greenest: 'Greenest',
      mostSecure: 'Most Secure',
      strongest: 'Strongest',
      easiest: 'Easiest',
      sustainable: 'sustainable',
      compatible: 'compatible',
      governedBy: 'Governed by Global Leaders',
      governedByDesc: 'Hedera is governed by a council of the world\'s leading organizations, ensuring decentralization, stability, and enterprise-grade reliability.',
      perfectFoundation: 'The Perfect Foundation for WhataLab',
      builtForEnterprise: 'Built for Enterprise',
      builtForEnterpriseDesc: 'Governed by world\'s leading corporations, ensuring stability and trust',
      unlimitedScalability: 'Unlimited Scalability',
      unlimitedScalabilityDesc: 'No theoretical limit on transactions per second with hashgraph technology',
      immediateFinality: 'Immediate Finality',
      immediateFinalityDesc: 'No forks, no rollbacks. Transactions are final the moment they\'re confirmed',
      futureProof: 'Future-Proof',
      futureProofDesc: 'Continuous innovation with regular network upgrades and new features',
      carbonNegativePoint: 'Carbon Negative',
      carbonNegativePointDesc: 'The only network that is carbon-negative, sustainable by design',
      predictableFees: 'Predictable Low Fees',
      predictableFeesDesc: 'Fixed USD fees as low as $0.0001, no gas wars or unpredictable costs',
      visionWords: 'Connecting Whata with the potential of Hashgraph',
    },

    // Tools Section
    tools: {
      badge: 'Powerful Hedera Tools',
      title: 'Our Tool Suite',
      subtitle: 'Everything you need to trade, track, and automate on Hedera.',
      learnMore: 'Learn More',
      comingSoon: 'Coming Soon',
      accessInfo: 'Access included with WhataKit NFT ownership',
      // Status
      statusLive: 'Live',
      statusUpcoming: 'Upcoming',
      statusInProgress: 'In progress',
      // Categories
      catAll: 'All',
      catNftTrading: 'NFT Trading',
      catHtsTrading: 'HTS Trading',
      catAnalytics: 'Analytics',
      catCreators: 'Creators',
      catProjectsFan: 'Projects Fan',
      catUtilityToken: 'Utility Token',
      // W·Sniper
      wsniperDesc: 'Advanced NFT sniper bot for instant acquisition of rare and valuable NFTs on Hedera network.',
      wsniperFeature1: 'Lightning Fast',
      wsniperFeature2: 'Auto-Bidding',
      wsniperFeature3: 'Rarity Detection',
      wsniperFeature4: 'Portfolio Analytics',
      // W·Scanner
      wscannerDesc: 'Comprehensive blockchain scanner and analytics tool for tracking wallets, transactions, and market data.',
      wscannerFeature1: 'Wallet Tracking',
      wscannerFeature2: 'Transaction Analysis',
      wscannerFeature3: 'Market Insights',
      wscannerFeature4: 'Real-time Data',
      // W·Trader
      wtraderDesc: 'Professional trading interface with advanced charting, portfolio management, and risk analysis.',
      wtraderFeature1: 'Advanced Charts',
      wtraderFeature2: 'Risk Management',
      wtraderFeature3: 'Portfolio Tracking',
      wtraderFeature4: 'API Integration',
      // W·Claimer
      wclaimerDesc: 'Automated token distribution system with percentage-based allocation and gamification rewards.',
      wclaimerFeature1: 'Auto Distribution',
      wclaimerFeature2: 'Percentage Allocation',
      wclaimerFeature3: 'Reward System',
      wclaimerFeature4: 'Smart Contracts',
      // W·Bridge
      wbridgeDesc: 'Comprehensive security tools for smart contract auditing and transaction verification.',
      wbridgeFeature1: 'Contract Auditing',
      wbridgeFeature2: 'Transaction Verification',
      wbridgeFeature3: 'Security Alerts',
      wbridgeFeature4: 'Risk Assessment',
      // W·Panel
      wpanelDesc: 'Multi-wallet portfolio tracker with P&L analysis, tax reporting, and performance metrics.',
      wpanelFeature1: 'Multi-Wallet',
      wpanelFeature2: 'P&L Analysis',
      wpanelFeature3: 'Tax Reports',
      wpanelFeature4: 'Performance Metrics',
      // W·Checker
      wcheckerDesc: 'Advanced verification and validation tool for NFT authenticity and smart contract security.',
      wcheckerFeature1: 'NFT Verification',
      wcheckerFeature2: 'Contract Analysis',
      wcheckerFeature3: 'Authenticity Check',
      wcheckerFeature4: 'Security Audit',
      // W·Boost
      wboostDesc: 'Utility token for enhanced features and premium access across the WhataLab ecosystem.',
      wboostFeature1: 'Premium Access',
      wboostFeature2: 'Enhanced Features',
      wboostFeature3: 'Staking Rewards',
      wboostFeature4: 'Governance Rights',
      // Actions
      launchTool: 'Launch Tool',
      tryBeta: 'Try Beta',
      // Custom CTAs per tool
      wsniperCta: 'Set a Snipe',
      wscannerCta: 'Make a Scan',
      wtraderCta: 'Set an Order',
      wclaimerCta: 'Create a Claim',
      wpanelCta: 'Create Roles',
      wcheckerCta: 'Check a Wallet',
      wboostCta: 'Add Usage',
      // CTA Section
      needCustom: 'Need Custom Solutions?',
      needCustomDesc: 'Our development team can create custom tools and integrations tailored to your specific needs.',
      contactUs: 'Contact Us',
    },

    // Ecosystem Section
    ecosystem: {
      badge: 'Shaping Our Vision',
      title: 'The WhataLab Universe',
      subtitle: 'Discover all the audiences we target with our portfolio of products.',
      learnMore: 'Learn More',
      getWhataKit: 'Get WhataKit',
      whataKitDesc: 'Your all-access pass to WhataLab tools and benefits.',
      // Cards
      tradersTitle: 'For Traders',
      tradersDesc: 'Access to premium & precision tools like sniper, orderbook & scanner, to dominate NFT & HTS token markets on Hedera.',
      tradersFeature1: 'Real-time analytics',
      tradersFeature2: 'Advanced sniping',
      tradersFeature3: 'Automated prices execution',
      tradersCta: 'Start Trade Now',
      fansTitle: 'For Fans',
      fansDesc: 'Join your favorite projects & communities with exclusive access to token gated content, rewards, and early opportunities.',
      fansFeature1: 'Token-gated access',
      fansFeature2: 'Community rewards',
      fansFeature3: 'Early opportunities',
      fansCta: 'Join Communities',
      creatorsTitle: 'For Creators',
      creatorsDesc: 'Scale & engage your Hedera community with Whata Bots, tokenized role granting & automated claimdrops campaigns.',
      creatorsFeature1: 'Smarter community growth',
      creatorsFeature2: 'Automated user rewards',
      creatorsFeature3: 'Scalable creator tools',
      creatorsCta: 'Create Claimdrop',
      enterpriseTitle: 'For Enterprise',
      enterpriseDesc: "Integrate Whata's modular Web3 tools into your product suite & access a pre-qualified Hedera audience ready for activation.",
      enterpriseFeature1: 'Ready-to-use audience',
      enterpriseFeature2: 'Plug-and-play modules',
      enterpriseFeature3: 'New revenue layers',
      enterpriseCta: 'Coming Soon',
      // Status
      statusReady: 'Ready',
      statusUpcoming: 'Upcoming',
      // Benefits
      benefitPlatformTitle: 'All-in-One Platform',
      benefitPlatformDesc: 'Manage NFTs, tokens, and DeFi automation in a single, seamless interface.',
      benefitInsightsTitle: 'Data-Driven Insights',
      benefitInsightsDesc: 'Get real-time analytics and actionable intelligence on collections, wallets, and market trends.',
      benefitToolsTitle: 'Next-Gen Web3 Tools',
      benefitToolsDesc: 'Automate tasks, launch claimdrops, engage communities, and enjoy a cutting-edge, intuitive design.',
      // CTA Section
      whyChoose: 'Why Choose WhataLab Ecosystem?',
      readyToJoin: 'Ready to Join the Lab?',
      readyToJoinDesc: 'Start your journey with WhataKit NFTs and unlock the full potential of our integrated blockchain ecosystem.',
      getEarlyPack: 'Get Early Pack',
      getWatt: 'Get WATT',
      convertToWboost: 'Convert to W·Boost',
    },

    // Modals
    modals: {
      chooseMarketplace: 'Choose your preferred marketplace',
      // Early Pack Modal
      earlyPackTitle: 'Get Early Pack NFTs',
      earlyPackDesc: 'Choose your preferred marketplace to purchase Early Pack NFTs and unlock exclusive benefits.',
      earlyPackBenefits: 'Early Pack Benefits:',
      earlyPackBenefitsDesc: 'Limited packages with management for communities, advanced verification, automatic lists, boosters and exclusive cumulative benefits.',
      // WATT Modal
      wattTitle: 'Get WATT NFTs',
      wattDesc: 'Choose your preferred marketplace to purchase WATT NFTs and get early access to the lab.',
      wattBenefits: 'WATT Benefits:',
      wattBenefitsDesc: 'The initial key to the Whatalab lab. Proof of early faith in the project with influence on future benefits and boosted packs.',
      // WhataKit Modal
      whataKitTitle: 'Get WhataKit NFTs',
      whataKitDesc: 'Choose your preferred marketplace to purchase WhataKit NFTs and unlock premium tools.',
      whataKitBenefits: 'WhataKit Benefits:',
      whataKitBenefitsDesc: 'Access to premium tools, exclusive features, and community governance in the WhataLab ecosystem.',
      // Marketplace buttons
      sentxMarket: 'SentX Market',
      kabilaMarket: 'Kabila Market',
      floorPrice: 'FP',
    },

    // FAQs Section
    faqs: {
      badge: 'Got Questions?',
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about WhataLab and our ecosystem.',
      stillQuestions: 'Still have questions?',
      joinCommunity: 'Join our Discord community for direct support and updates.',
      joinDiscord: 'Join Discord',
    },

    // Footer
    footer: {
      poweredBy: 'Powered by',
      allRightsReserved: 'All rights reserved.',
      // Platform section
      platform: 'Platform',
      toolsPlatform: 'Tools Platform',
      wPanel: 'W·Panel',
      buyWboost: 'Buy W·Boost',
      // Community section
      community: 'Community',
      discord: 'Discord',
      twitterX: 'Twitter / X',
      podcast: 'Podcast',
    },

    // CTAs
    cta: {
      launchApp: 'Launch App',
      wPanel: 'W·Panel',
    },

    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      close: 'Close',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
    },
  },

  es: {
    // Navegación
    nav: {
      home: 'Inicio',
      about: 'Nosotros',
      whyHedera: 'Por qué Hedera',
      tools: 'Herramientas',
      ecosystem: 'Ecosistema',
      whataSpace: 'WhataSpace',
      whataNews: 'WhataNews',
      faqs: 'Preguntas',
    },

    // Sección Hero
    hero: {
      allInOne: 'Opera. Verifica. Automatiza.',
      hederaUtilitySuite: 'Todo en Un Solo Lugar.',
      description: 'Conecta tu negocio al Web3. Nacido en comunidad, listo para empresas.',
      lightningFast: 'Ultra Rápido',
      enterpriseGrade: 'Nivel Empresarial',
      completeSuite: 'Suite Completa',
      advancedTools: 'Herramientas Avanzadas',
      exploreToolkit: 'Explorar Herramientas',
      joinDiscord: 'Únete a Discord',
      releasedSupply: 'SUPPLY LIBERADO',
      totalHolders: 'Holders Totales',
      liveStats: 'Estadísticas en vivo de SentX API',
    },

    // Sección About
    about: {
      badge: 'Construido en Hedera. Diseñado para Hbarbarians.',
      title: 'Sobre WhataLab',
      ourMission: 'Nuestra Misión',
      missionText1: 'WhataLab es un laboratorio de innovación nacido de la comunidad que transforma cómo interactuamos con Web3. Fundado por cinco expertos en producto, crecimiento comunitario y blockchain, su misión es hacer Web3 útil, accesible y funcional en el mundo real.',
      missionText2: 'En un entorno lleno de promesas vacías, nos enfocamos en herramientas prácticas: desde validación de roles NFT hasta sistemas de automatización y verificación en Discord, simplificando la vida digital en Hedera. Nuestra filosofía de utilidad radical busca integrar Web2 y Web3 sin fisuras.',
      missionText3: 'Construimos en Hedera por su velocidad, sostenibilidad y escalabilidad. Porque Web3 no trata de promesas futuras, sino de acciones presentes.',
      ourAchievements: 'Nuestros Logros',
      listenWhataSpace: 'Escuchar WhataSpace',
      readWhataNews: 'Leer WhataNews',
      tokenRoleValidation: 'Validación de Roles por Token',
      tokenRoleDesc: 'Primera plataforma web para validación de roles de NFT y tokens HTS en Hedera para comunidades, con extensión para Discord y próximamente Telegram.',
      tokenTrading: 'Plataforma de Trading',
      tokenTradingDesc: 'Combina el poder del primer Sniper para Hbarbarians con un libro de órdenes con precio límite, conectado con los mejores mercados NFT y plataformas DeFi de Hedera.',
      validatedByMarkets: 'Validado por Mercados Oficiales',
      validatedDesc: 'Respaldado por SentX y Kabila, los principales marketplaces NFT de Hedera',
      officialDapp: 'dApp Oficial en Kabila',
      officialDappDesc: 'Ahora disponible en todas las wallets de Kabila con un solo clic',
      whataRoadmap: 'WhataRoadmap',
      roadmapSubtitle: 'Protocolo activo, experimentos en progreso para optimizar cada fase del ecosistema.',
      done: 'Hecho',
      working: 'En Proceso',
      upcoming: 'Próximo',
      joinOurJourney: 'Únete a Nuestro Viaje',
      joinOurJourneyDesc: 'Sé parte de la revolución y ayuda a dar forma al futuro de la tecnología blockchain. Tu feedback y participación impulsan nuestro desarrollo.',
      getStarted: 'Comenzar',
      giveFeedback: 'Dar Feedback',
      // Roadmap Q4 2023
      roadmapQ42023Title: 'Lanzamiento del Proyecto',
      roadmapQ42023Item1: 'Presentación de branding',
      roadmapQ42023Item2: 'Lanzamiento Colección NFT WATT',
      roadmapQ42023Item3: 'Lanzamiento MVP W·Panel',
      // Roadmap H1 2024
      roadmapH12024Title: 'Desarrollo del Proyecto',
      roadmapH12024Item1: 'Evolución del MVP',
      roadmapH12024Item2: 'Feedback de clientes',
      roadmapH12024Item3: 'Investigación de mercado para nuevas herramientas',
      roadmapH12024Item4: 'Colaboraciones con comunidades Hedera',
      roadmapH12024Item5: 'Captar más clientes',
      // Roadmap H2 2024
      roadmapH22024Title: 'Más que un MVP',
      roadmapH22024Item1: 'Planificar nueva línea de productos',
      roadmapH22024Item2: 'Añadir socios profesionales al equipo',
      roadmapH22024Item3: 'Convertir el proyecto en una empresa real',
      roadmapH22024Item4: 'Definir WPanel V1 con inputs profesionales',
      // Roadmap H1 2025
      roadmapH12025Title: 'Whata Hub Enterprise',
      roadmapH12025Item1: 'Establecer una empresa SL Española',
      roadmapH12025Item2: 'Lanzar WhataKit NFTs y Token W·Boost',
      roadmapH12025Item3: 'Lanzar MVP W·Sniper',
      roadmapH12025Item4: 'Partner oficial de SentX',
      roadmapH12025Item5: 'Comenzar desarrollo de nuevas herramientas',
      // Roadmap H2 2025
      roadmapH22025Title: 'Whata Hub Enterprise',
      roadmapH22025Item1: 'Lanzar W·Sniper W·Scanner W·Trader y W·Claimer V1',
      roadmapH22025Item2: 'Lanzar nueva web principal y podcast W·Space',
      roadmapH22025Item3: 'Captación de capital externo con nuevos inversores',
      roadmapH22025Item4: 'Reestructuración del equipo de desarrollo',
      // Roadmap Q1 2026
      roadmapQ12026Title: 'Nuevos Horizontes',
      roadmapQ12026Item1: 'Lanzar WhataNews Blog',
      roadmapQ12026Item2: 'Lanzar W·Bridge',
      roadmapQ12026Item3: 'Lanzar W·Panel V2 para creadores',
      roadmapQ12026Item4: 'Lanzar W·Panel V1 para Holders',
      roadmapQ12026Item5: 'dApp oficial en Wallets Kabila y HashPack',
      // WhataTeam
      whataTeam: 'WhataTeam',
      teamSubtitle: 'Las mentes detrás de WhataLab. Un equipo unido por la pasión por blockchain y el compromiso de construir herramientas útiles.',
      roleRober: 'Fundador · CEO & Diseñador',
      roleMartin: 'Fundador · COO & Asesor',
      rolePedro: 'Fundador · COS & Asesor Hedera',
      roleSergio: 'Fundador · CTO & VP Product',
      roleBeanie: 'CM & Discord Manager',
      roberDesc: 'Experto en proyectos tokenizados con enfoque en Hedera, Publicidad y MK. El Diseñador y Líder Creativo de Whata.',
      martinDesc: 'Notable experiencia en finanzas, blockchain y crecimiento de startups tech. El Asesor total del proyecto.',
      pedroDesc: 'Experto en Comunidades Hedera, servicio al cliente pre y post venta y coordinación de relaciones públicas.',
      sergioDesc: '6+ años de experiencia en Dev Blockchain, escalando apps, smart contracts y sistemas descentralizados.',
      beanieDesc: 'Experto en engagement comunitario. Gestionando Discord y manteniendo la comunidad WhataLab conectada y activa.',
    },

    // Sección Why Hedera
    whyHedera: {
      poweredBy: 'Impulsado por Tecnología Hashgraph',
      title: 'Por Qué Construimos en Hedera',
      subtitle: 'La tecnología de registro distribuido más avanzada del mundo. Rápida, justa y segura con el menor impacto ambiental de la industria.',
      lightningSpeed: 'Velocidad Relámpago',
      lightningSpeedDesc: 'Las transacciones finalizan en 3-5 segundos con consenso hashgraph',
      ultraLowCost: 'Coste Ultra Bajo',
      ultraLowCostDesc: 'Tarifas predecibles y transparentes que no fluctúan con la congestión de la red',
      carbonNegative: 'Carbono Negativo',
      carbonNegativeDesc: 'La tecnología de registro distribuido más eficiente energéticamente',
      bankGradeSecurity: 'Seguridad Bancaria',
      bankGradeSecurityDesc: 'Tolerancia a Fallos Bizantinos Asíncrona - el nivel más alto de seguridad',
      hbarbarians: 'Comunidad HBarbarians',
      hbarbariansDesc: 'Ecosistema vibrante de desarrolladores, creadores e innovadores construyendo juntos',
      developerFriendly: 'Amigable para Desarrolladores',
      developerFriendlyDesc: 'Herramientas y lenguajes familiares con compatibilidad EVM para migración sin problemas',
      fastest: 'Más Rápido',
      cheapest: 'Más Económico',
      greenest: 'Más Verde',
      mostSecure: 'Más Seguro',
      strongest: 'Más Fuerte',
      easiest: 'Más Fácil',
      sustainable: 'sostenible',
      compatible: 'compatible',
      governedBy: 'Gobernado por Líderes Globales',
      governedByDesc: 'Hedera está gobernado por un consejo de las organizaciones líderes mundiales, asegurando descentralización, estabilidad y fiabilidad empresarial.',
      perfectFoundation: 'La Base Perfecta para WhataLab',
      builtForEnterprise: 'Diseñado para Empresas',
      builtForEnterpriseDesc: 'Gobernado por las principales corporaciones del mundo, garantizando estabilidad y confianza',
      unlimitedScalability: 'Escalabilidad Ilimitada',
      unlimitedScalabilityDesc: 'Sin límite teórico de transacciones por segundo con tecnología hashgraph',
      immediateFinality: 'Finalidad Inmediata',
      immediateFinalityDesc: 'Sin bifurcaciones, sin reversiones. Las transacciones son finales en el momento de confirmarse',
      futureProof: 'A Prueba de Futuro',
      futureProofDesc: 'Innovación continua con actualizaciones regulares de la red y nuevas características',
      carbonNegativePoint: 'Carbono Negativo',
      carbonNegativePointDesc: 'La única red que es carbono-negativa, sostenible por diseño',
      predictableFees: 'Tarifas Bajas Predecibles',
      predictableFeesDesc: 'Tarifas fijas en USD desde $0.0001, sin guerras de gas ni costes impredecibles',
      visionWords: 'Conectando Whata con el potencial de Hashgraph',
    },

    // Sección Tools
    tools: {
      badge: 'Potentes Herramientas Hedera',
      title: 'Nuestra Suite de Herramientas',
      subtitle: 'Todo lo que necesitas para operar, rastrear y automatizar en Hedera.',
      learnMore: 'Saber Más',
      comingSoon: 'Próximamente',
      accessInfo: 'Acceso incluido con la propiedad del NFT WhataKit',
      // Status
      statusLive: 'Activo',
      statusUpcoming: 'Próximo',
      statusInProgress: 'En progreso',
      // Categories
      catAll: 'Todos',
      catNftTrading: 'Trading NFT',
      catHtsTrading: 'Trading HTS',
      catAnalytics: 'Analíticas',
      catCreators: 'Creadores',
      catProjectsFan: 'Fans de Proyectos',
      catUtilityToken: 'Token de Utilidad',
      // W·Sniper
      wsniperDesc: 'Bot sniper avanzado de NFT para adquisición instantánea de NFTs raros y valiosos en la red Hedera.',
      wsniperFeature1: 'Ultra Rápido',
      wsniperFeature2: 'Auto-Puja',
      wsniperFeature3: 'Detección de Rareza',
      wsniperFeature4: 'Analíticas de Portfolio',
      // W·Scanner
      wscannerDesc: 'Escáner blockchain completo y herramienta de analíticas para rastrear wallets, transacciones y datos de mercado.',
      wscannerFeature1: 'Rastreo de Wallets',
      wscannerFeature2: 'Análisis de Transacciones',
      wscannerFeature3: 'Insights de Mercado',
      wscannerFeature4: 'Datos en Tiempo Real',
      // W·Trader
      wtraderDesc: 'Interfaz de trading profesional con gráficos avanzados, gestión de portfolio y análisis de riesgo.',
      wtraderFeature1: 'Gráficos Avanzados',
      wtraderFeature2: 'Gestión de Riesgo',
      wtraderFeature3: 'Seguimiento de Portfolio',
      wtraderFeature4: 'Integración API',
      // W·Claimer
      wclaimerDesc: 'Sistema automatizado de distribución de tokens con asignación basada en porcentajes y recompensas gamificadas.',
      wclaimerFeature1: 'Distribución Automática',
      wclaimerFeature2: 'Asignación Porcentual',
      wclaimerFeature3: 'Sistema de Recompensas',
      wclaimerFeature4: 'Smart Contracts',
      // W·Bridge
      wbridgeDesc: 'Herramientas de seguridad completas para auditoría de smart contracts y verificación de transacciones.',
      wbridgeFeature1: 'Auditoría de Contratos',
      wbridgeFeature2: 'Verificación de Transacciones',
      wbridgeFeature3: 'Alertas de Seguridad',
      wbridgeFeature4: 'Evaluación de Riesgo',
      // W·Panel
      wpanelDesc: 'Rastreador de portfolio multi-wallet con análisis P&L, informes fiscales y métricas de rendimiento.',
      wpanelFeature1: 'Multi-Wallet',
      wpanelFeature2: 'Análisis P&L',
      wpanelFeature3: 'Informes Fiscales',
      wpanelFeature4: 'Métricas de Rendimiento',
      // W·Checker
      wcheckerDesc: 'Herramienta avanzada de verificación y validación para autenticidad de NFT y seguridad de smart contracts.',
      wcheckerFeature1: 'Verificación de NFT',
      wcheckerFeature2: 'Análisis de Contratos',
      wcheckerFeature3: 'Comprobación de Autenticidad',
      wcheckerFeature4: 'Auditoría de Seguridad',
      // W·Boost
      wboostDesc: 'Token de utilidad para funciones mejoradas y acceso premium en todo el ecosistema WhataLab.',
      wboostFeature1: 'Acceso Premium',
      wboostFeature2: 'Funciones Mejoradas',
      wboostFeature3: 'Recompensas de Staking',
      wboostFeature4: 'Derechos de Gobernanza',
      // Actions
      launchTool: 'Abrir Herramienta',
      tryBeta: 'Probar Beta',
      // Custom CTAs per tool
      wsniperCta: 'Hacer un Snipe',
      wscannerCta: 'Hacer un Escaneo',
      wtraderCta: 'Crear una Orden',
      wclaimerCta: 'Crear un Claim',
      wpanelCta: 'Crear Roles',
      wcheckerCta: 'Verificar Wallet',
      wboostCta: 'Añadir Uso',
      // CTA Section
      needCustom: '¿Necesitas Soluciones Personalizadas?',
      needCustomDesc: 'Nuestro equipo de desarrollo puede crear herramientas e integraciones personalizadas adaptadas a tus necesidades específicas.',
      contactUs: 'Contáctanos',
    },

    // Sección Ecosystem
    ecosystem: {
      badge: 'Dando Forma a Nuestra Visión',
      title: 'El Universo WhataLab',
      subtitle: 'Descubre todos los públicos a los que dirigimos el enfoque de nuestra cartera de productos creados.',
      learnMore: 'Saber Más',
      getWhataKit: 'Obtener WhataKit',
      whataKitDesc: 'Tu pase de acceso total a las herramientas y beneficios de WhataLab.',
      // Cards
      tradersTitle: 'Para Traders',
      tradersDesc: 'Acceso a herramientas premium y de precisión como sniper, libro de órdenes y escáner, para dominar los mercados de NFT y tokens HTS en Hedera.',
      tradersFeature1: 'Analíticas en tiempo real',
      tradersFeature2: 'Sniping avanzado',
      tradersFeature3: 'Ejecución automatizada de precios',
      tradersCta: 'Empezar a Tradear',
      fansTitle: 'Para Fans',
      fansDesc: 'Únete a tus proyectos y comunidades favoritas con acceso exclusivo a contenido tokenizado, recompensas y oportunidades anticipadas.',
      fansFeature1: 'Acceso por token',
      fansFeature2: 'Recompensas comunitarias',
      fansFeature3: 'Oportunidades anticipadas',
      fansCta: 'Unirse a Comunidades',
      creatorsTitle: 'Para Creadores',
      creatorsDesc: 'Escala e involucra a tu comunidad Hedera con Whata Bots, asignación de roles tokenizados y campañas automatizadas de claimdrops.',
      creatorsFeature1: 'Crecimiento comunitario inteligente',
      creatorsFeature2: 'Recompensas automatizadas',
      creatorsFeature3: 'Herramientas escalables',
      creatorsCta: 'Crear Claimdrop',
      enterpriseTitle: 'Para Empresas',
      enterpriseDesc: 'Integra las herramientas modulares Web3 de Whata en tu suite de productos y accede a una audiencia Hedera precalificada lista para activar.',
      enterpriseFeature1: 'Audiencia lista para usar',
      enterpriseFeature2: 'Módulos plug-and-play',
      enterpriseFeature3: 'Nuevas capas de ingresos',
      enterpriseCta: 'Próximamente',
      // Status
      statusReady: 'Listo',
      statusUpcoming: 'Próximo',
      // Benefits
      benefitPlatformTitle: 'Plataforma Todo en Uno',
      benefitPlatformDesc: 'Gestiona NFTs, tokens y automatización DeFi en una única interfaz integrada.',
      benefitInsightsTitle: 'Insights Basados en Datos',
      benefitInsightsDesc: 'Obtén analíticas en tiempo real e inteligencia accionable sobre colecciones, wallets y tendencias del mercado.',
      benefitToolsTitle: 'Herramientas Web3 de Nueva Generación',
      benefitToolsDesc: 'Automatiza tareas, lanza claimdrops, involucra comunidades y disfruta de un diseño intuitivo y vanguardista.',
      // CTA Section
      whyChoose: '¿Por Qué Elegir el Ecosistema WhataLab?',
      readyToJoin: '¿Listo para Unirte al Lab?',
      readyToJoinDesc: 'Comienza tu viaje con los NFTs WhataKit y desbloquea todo el potencial de nuestro ecosistema blockchain integrado.',
      getEarlyPack: 'Obtener Early Pack',
      getWatt: 'Obtener WATT',
      convertToWboost: 'Convertir a W·Boost',
    },

    // Modales
    modals: {
      chooseMarketplace: 'Elige tu marketplace preferido',
      // Early Pack Modal
      earlyPackTitle: 'Obtener Early Pack NFTs',
      earlyPackDesc: 'Elige tu marketplace preferido para comprar Early Pack NFTs y desbloquear beneficios exclusivos.',
      earlyPackBenefits: 'Beneficios Early Pack:',
      earlyPackBenefitsDesc: 'Paquetes limitados con gestión para comunidades, verificación avanzada, listas automáticas, boosters y beneficios acumulativos exclusivos.',
      // WATT Modal
      wattTitle: 'Obtener WATT NFTs',
      wattDesc: 'Elige tu marketplace preferido para comprar WATT NFTs y obtener acceso anticipado al lab.',
      wattBenefits: 'Beneficios WATT:',
      wattBenefitsDesc: 'La llave inicial al laboratorio Whatalab. Prueba de fe temprana en el proyecto con influencia en futuros beneficios y packs potenciados.',
      // WhataKit Modal
      whataKitTitle: 'Obtener WhataKit NFTs',
      whataKitDesc: 'Elige tu marketplace preferido para comprar WhataKit NFTs y desbloquear herramientas premium.',
      whataKitBenefits: 'Beneficios WhataKit:',
      whataKitBenefitsDesc: 'Acceso a herramientas premium, funciones exclusivas y gobernanza comunitaria en el ecosistema WhataLab.',
      // Marketplace buttons
      sentxMarket: 'Mercado SentX',
      kabilaMarket: 'Mercado Kabila',
      floorPrice: 'FP',
    },

    // Sección FAQs
    faqs: {
      badge: '¿Tienes Preguntas?',
      title: 'Preguntas Frecuentes',
      subtitle: 'Todo lo que necesitas saber sobre WhataLab y nuestro ecosistema.',
      stillQuestions: '¿Aún tienes preguntas?',
      joinCommunity: 'Únete a nuestra comunidad de Discord para soporte directo y actualizaciones.',
      joinDiscord: 'Únete a Discord',
    },

    // Footer
    footer: {
      poweredBy: 'Desarrollado por',
      allRightsReserved: 'Todos los derechos reservados.',
      // Platform section
      platform: 'Plataforma',
      toolsPlatform: 'Plataforma de Herramientas',
      wPanel: 'W·Panel',
      buyWboost: 'Comprar W·Boost',
      // Community section
      community: 'Comunidad',
      discord: 'Discord',
      twitterX: 'Twitter / X',
      podcast: 'Podcast',
    },

    // CTAs
    cta: {
      launchApp: 'Abrir App',
      wPanel: 'W·Panel',
    },

    // Común
    common: {
      loading: 'Cargando...',
      error: 'Error',
      close: 'Cerrar',
      openMenu: 'Abrir menú',
      closeMenu: 'Cerrar menú',
    },
  },
};

export default translations;
